const NotFoundMessage = 'Not Found'

class NotFoundError extends Error {
  constructor() {
    super(NotFoundMessage)
  }
}

export { NotFoundError, NotFoundMessage }
